import { render } from "./vue-slider.vue?vue&type=template&id=c905cf76&ts=true"
import script from "./vue-slider.vue?vue&type=script&lang=ts"
export * from "./vue-slider.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/mujie.chen/Projects/mine/vue-slider-component/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.72.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__